import api from '../helpers';

export default {
  register: {
    key: 'deviceId',
    query: ({ deviceId }) => {
      return api.get(`/api/device/${deviceId}`);
    },
  },
  registerDevices: {
    key: 'registerDevices',
    query: (deviceIds) => {
      return api.post('/api/devices', {
        headers: {
          'Content-Type': 'application/json',
        },
        data: { deviceIds },
      });
    },
  },
  getDevices: {
    key: 'fetchDevices',
    query: (companyId, offset = 0, limit = -1) => {
      return api.get(`/api/devices/${companyId}?offset=${offset}&limit=${limit}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    },
    mapper: ({ data }) => {
      return data.map((model) => model);
    },
  },
  edit: {
    key: 'editDevice',
    query: (id, data) => {
      return api.put(`/api/devices/${id}`, {
        headers: {
          'Content-Type': 'application/json',
        },
        data,
      });
    },
  },
};
